import PropTypes from "prop-types";
import styles from "./FilterMenu.module.css";
import React, { useEffect, useState, useRef } from "react";
import IconFilter from "./Images/filter-50.png";
import IconArrow from "./Images/arrow-26.png";
import IconCheck from "./Images/check-24.png";
import { useTranslation } from "react-i18next";

export function FilterMenu({ groups, onChange, selected }) {
  const {t} = useTranslation();
  const [selectedFilters, setSelectedFilters] = useState(new Set(selected));
  const [filteredOptions, setFilteredOptions] = useState(groups);
  const [isOpen, setIsOpen] = useState(false);
  const comboBoxRef = useRef(null);

  const handleOptionClick = (groupName, item) => {
    const filterKey = `${item}`;
    const updatedFilters = new Set(selectedFilters);

    // Remove any previously selected item from this group
    const groupItems = groups.find((g) => g.name === groupName)?.items || [];
    groupItems.forEach((i) => updatedFilters.delete(`${i}`));

    // Toggle current selection
    if (!selectedFilters.has(filterKey)) {
      updatedFilters.add(filterKey);
    }

    setSelectedFilters(updatedFilters);
    onChange(Array.from(updatedFilters));
    setIsOpen(true);
  };
  

  const toggleDropdown = () => {
    setIsOpen(prevState => !prevState);
  };

  // Close dropdown if clicking outside of component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (comboBoxRef.current && !comboBoxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={comboBoxRef} className={styles.wrapper}>
      <div className={styles.comboboxContainer} onClick={toggleDropdown}>
        <div className={styles.leftColumn}>
          <img src={IconFilter} className={styles.iconFilter} alt="" />
        </div>
        <div className={styles.rightColumn}>
          <img src={IconArrow} className={styles.iconArrow} alt="" />
        </div>
      </div>
      {isOpen && (
        <div className={styles.optionsContainer}>
          {groups.map((group, groupIndex) => (
            <React.Fragment key={group.name}>
              {group.items.length > 0 ? (
                group.items.map((item, itemIndex) => {
                  const filterKey = `${item}`;
                  return (
                    <div
                      className={styles.optionContainer}
                      key={itemIndex}
                      onClick={() => handleOptionClick(group.name, item)}>
                      <div className={styles.optionIcon}>
                        {selectedFilters.has(filterKey) && <img src={IconCheck} className={styles.iconCheck} alt="" />}
                      </div>
                      <div className={styles.optionName}>{t(item)}</div>
                    </div>
                  );
                })
              ) : (
                <div className={styles.optionContainer} key={`${group.name}-no-options`}>
                  <div className={styles.optionIcon}></div>
                  <div className={styles.optionName}>{t("No options found")}</div>
                </div>
              )}
              {groupIndex < groups.length - 1 && <hr className={styles.separator} />}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}


FilterMenu.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string.isRequired),
};
